import { useEffect } from 'react';
import type { RefObject } from 'react';

/**
 * Custom hook to disable wheel events on a container element
 * @param containerRef - RefObject pointing to the container element
 */
export const useDisableWheelEvent = (containerRef: RefObject<HTMLElement | null>) => {
    useEffect(() => {
        const handleWheel = (e: WheelEvent) => {
            e.preventDefault();
            e.stopPropagation();
        };

        const container = containerRef.current;
        if (!container) return;
        container.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, [containerRef]);
};
